type Props = {
    day: Date;
};

export function CalendarPageDayHeader({ day }: Props) {
    return (
        <div
            data-slot="calendar-page-day-header"
            className="flex h-12.25 w-full items-center border-b border-border bg-card px-4 py-1 shadow-xs"
        >
            <div className="flex w-8 flex-col items-center">
                <span className="flex h-5.25 items-center justify-center text-xs leading-4 text-muted-foreground uppercase">
                    {day.toLocaleDateString('en-US', { weekday: 'short' })}
                </span>
                <span className="flex h-5 items-center justify-center text-sm leading-5 font-medium text-foreground">
                    {day.getDate()}
                </span>
            </div>
        </div>
    );
}
